import React from 'react'

const Lock = () => {
  return (
    <svg 
      fill="currentColor"
      width="28" 
      height="28" 
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMinYMin"
      className="jam jam-lock"
    >
      <path d="M17 8h-1V6a4 4 0 0 0-8 0v2H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2zm-7-2a2 2 0 1 1 4 0v2h-4V6zm5 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>
    </svg>
  );
};


export default Lock
